module.exports = "/static/assets/13845e22946385773258430cbb9f7b1a.png";